import { observable } from "mobx"

import type { User as UserJson } from "~/api/me/get"
import type { UnreadMessageConnectionCount } from "~/api/student/message_connection/unread_message_connection_count/get"

export interface TmpUserInfo {
  name: string | null
  phoneNumber?: string | null
  email?: string | null
}

export class User {
  @observable json: UserJson
  @observable id: number
  @observable email: string
  @observable name: string
  @observable year: string
  @observable type: string
  @observable profileImg: string
  @observable coverImgFilename: string
  @observable unreadMessageCount: number
  @observable emailVerifiedAt: string | null
  @observable createdAt: string
  @observable newGradsCampaign: boolean
  @observable graduatesIn?: number

  constructor(userJson: UserJson, unreadMessageConnectionCountJson: UnreadMessageConnectionCount) {
    this.json = userJson

    this.id = userJson.id
    this.email = userJson.email
    this.name = userJson.name
    this.year = userJson.year
    this.type = userJson.user_type
    this.profileImg = userJson.profile_img
    this.coverImgFilename = userJson.cover_img_filename
    this.emailVerifiedAt = userJson.email_verified_at
    this.createdAt = userJson.created_at
    this.newGradsCampaign = Boolean(userJson.new_grads_campaign)
    this.graduatesIn = userJson.graduates_in
    this.unreadMessageCount = unreadMessageConnectionCountJson.count
  }
}
